"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var theme_ui_1 = require("theme-ui");
exports.Heading = function (_a) {
    var variant = _a.variant, _b = _a.as, as = _b === void 0 ? "h1" : _b, sx = _a.sx, children = _a.children;
    if (!variant) {
        variant = as;
    }
    return (react_1.default.createElement(theme_ui_1.Heading, { as: as, variant: variant, sx: sx || undefined }, children));
};
